// extracted by css-extract-rspack-plugin
export default {"teammate":"teammate-module__teammate--q48er","breadcrumb":"teammate-module__breadcrumb--rL6Br"};